import React, { useEffect, useState } from "react";
import { AutoComplete, ConfigProvider } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const StaticAutoComplete = ({
  optionsList = [],
  onSelect,
  placeholder = "Select",
  showAddNew = false,
  value,   // optional parent-controlled value
  onChange
}) => {
  const [inputValue, setInputValue] = useState("");

  // ✅ Keep display text in sync when parent passes new value
  useEffect(() => {
  if (value && (typeof value === "string" || Object.keys(value).length > 0)) {
    const text =
      typeof value === "string"
        ? value
        : value.display_text ||
          value.voucher_no ||
          value.sale_voucher_no ||
          value.acc_name ||
          "";
    setInputValue(text);
  }
  // 🚫 Don't reset to empty unless we explicitly know value is null or cleared
  else if (value === null) {
    setInputValue("");
  }
}, [value]);


  const formattedOptions = optionsList.map((item) => {
  // Determine the best label text dynamically  
  const labelText =
    item.display_text ||
    item.voucher_no ||    // ✅ added for sales vouchers
    item.sale_voucher_no || 
    item.acc_name ||
    item.name ||
    "";

  return {
    value: String(item.sale_id || item.acc_id || item.id),
    label: <div>{labelText}</div>,
    obj: { ...item, display_text: labelText }, // ✅ ensure display_text always exists
  };
});

  const finalOptions = showAddNew
    ? [
        {
          value: "add_new",
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 500,
              }}
            >
              <PlusOutlined style={{ marginRight: 8 }} /> Add New
            </div>
          ),
        },
        ...formattedOptions,
      ]
    : formattedOptions;

  const handleSelect = (val, option) => {
    if (val === "add_new") {
      onSelect("add_new");
      return;
    }
    const selected = option?.obj || null;
    const labelText = selected?.display_text || selected?.voucher_no || selected?.acc_name || "";

    setInputValue(labelText);
    onSelect(selected);
  };

  // const handleChange = (val) => {
  //   // Only update internal state if parent isn't controlling
  //   if (!value) setInputValue(val);

  //   if (!val) onSelect(null);
  //   if (onChange) onChange(val);
  // };

  // ✅ Manual typing or clearing
  const handleChange = (val) => {
    setInputValue(val);
    if (!val) onSelect(null); // clear selection if emptied
    if (onChange) onChange(val);
  };


  return (
    <ConfigProvider>
      <AutoComplete
        options={finalOptions}
        value={inputValue } // use inputValue which may be synced
        onChange={handleChange}
        onSelect={handleSelect}
        placeholder={placeholder}
        size="large"
        allowClear 
        style={{ width: "100%", fontSize: "16px" }}
        filterOption={(input, option) =>
          (option?.label?.props?.children || "")
            .toString()
            .toLowerCase()
            .includes(input.toLowerCase())
        } // ✅ ensures search still works
      />
    </ConfigProvider>
  );
};

export default StaticAutoComplete;
